let pic = require('./modules/pic/');
// let LiveSlide = require('./modules/slide/');
let LivePhotoSwipe = require('./modules/photoSwipe/');

// let liveslide;

let Ppt = function(container, options) {
    this.init(container, options);
    this.LivePhotoSwipes = null;
};

Ppt.prototype.init = function(container, options) {
    // let defaultData = {
    //     pictures: options.pictures,
    //     index: '0',
    //     imageSrc: options.pictures[0].url,
    //     picLength: options.pictures.length
    // };
    // if (typeof liveslide === 'undefined') {
    //     liveslide = new LiveSlide(defaultData);
    // }
    this.resolveTemplate(container, options);
    this.bindDomEvent(container, options.pictures);
};

Ppt.prototype.resolveTemplate = function(container, options) {
    let picHtml = pic(options.pictures, options.mid);
    $(container).append(picHtml);
};

Ppt.prototype.bindDomEvent = function(container, pictures) {
    $(container).on('click', '[data-index]', function() {
        let index = $(this).data('index');
        const swipeOtions = {
            pictures: pictures,
            index: index
        };
        // 在点击时初始化
        this.LivePhotoSwipes = new LivePhotoSwipe(swipeOtions);
        this.LivePhotoSwipes.showSwipe();
        // liveslide.show(pictures, index);
    });
};

module.exports = Ppt;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.pic.mobile/app/index.js